<template>
  <div>
    <gatherBasis :cells="cells" :type="type">
      <template #column>
        <el-table-column align="center" header-align="center" label="检查人数" prop="sum" width="150px"/>
        <el-table-column v-for="item in cells" :label="item.name" align="center" header-align="center">
          <el-table-column :prop="item.prop" align="center" header-align="center" label="人数"/>
          <el-table-column :prop="item.prop+'Ratio'" align="center" header-align="center" label="百分比"/>
        </el-table-column>
      </template>
    </gatherBasis>
  </div>

</template>
<script>
import gatherBasis from "../components/gatherBasis.vue"
/*舒张压评价等级报表*/
export default {
  name: "gatherBloodDiastolic",
  components: {
    gatherBasis
  },
  data() {
    return {
      type: "bloodDiastolic",
      cells: [
        {prop: "r096_0", name: '偏低'},
        {prop: "r096_1", name: '正常'},
        {prop: "r096_2", name: '偏高'},
      ]
    }
  },
  mounted() {
  },
  methods: {}
}
</script>
<style scoped>

</style>